import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ChevronsUp: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm17 11-5-5-5 5' }],
    ['path', { d: 'm17 18-5-5-5 5' }],
  ],
];

export default ChevronsUp;
